import React from "react";
import { Field, Formik } from "formik";
import { object } from "yup";
import { Col } from "react-bootstrap";
import { MaterialSelect } from "../../payments/components/select-field.component";
import { TextField } from "formik-material-ui";
import { CheckboxWithLabel } from "formik-material-ui";
import Button from "@material-ui/core/Button/Button";

const INVOICE_STATUS_OPTIONS = [
  { value: "draft", label: "Rascunho" },
  { value: "final", label: "Final" },
  { value: "settled", label: "Paga" },
];

const validationSchema = object().shape({});

const handleSubmitting = (fn) => (values, actions) => {
  fn(values);
  actions.setSubmitting(false);
};

const invoice_status_promise = async () => {
  return INVOICE_STATUS_OPTIONS;
};

export const RequestsHistoryFilterForm = ({ onChange, searchValues }) => (
  <Col>
    <Formik
      initialValues={{ ...searchValues }}
      onSubmit={handleSubmitting(onChange)}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      render={({ values, handleSubmit, setFieldValue, setFieldTouched }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Field
              name="admission_date_lte"
              label="Data admissão <="
              type="date"
              variant="outlined"
              margin="normal"
              component={TextField}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={setFieldValue}
              value={"" + values.admission_date_lte}
            />
            <Field
              name="admission_date_gte"
              label="Data admissão >="
              type="date"
              variant="outlined"
              margin="normal"
              component={TextField}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={setFieldValue}
              value={"" + values.admission_date_gte}
            />
            <MaterialSelect
              name="invoice_status"
              placeholder="invoice_status"
              label="Estado fatura"
              value={"" + values.invoice_status}
              onBlur={setFieldTouched}
              onChange={setFieldValue}
              optionsFetcher={invoice_status_promise}
            />
            <Field
              name="pending_payments"
              Label={{ label: "Cobranças pendentes" }}
              component={CheckboxWithLabel}
              onChange={setFieldValue}
              value={"" + values.pending_payments}
            />
            <Button variant="contained" type="submit" size="small">
              Filtrar
            </Button>
          </form>
        );
      }}
    />
  </Col>
);
